import { createContext, useContext, useState, useCallback } from "react";
import { content } from "@/data/content";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState("es");
  const toggle = useCallback(() => setLang((l) => (l === "es" ? "en" : "es")), []);
  const t = content[lang];
  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
